import { SchedulerConstants } from './Scheduler.constants';

const initialState = {
    data: {},
    appliedFilters: {
        sort: 'desc',
        limit: '10',
        pageNumber: '1',
        searchBy: '',
        searchValue: '',
        module:'REPORT'
    },
    emptyCheck: {}
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // Empty Check
        case SchedulerConstants.GET_SCHEDULER_EMPTY_CHECK_REQUEST:
            return {
                ...state,
                emptyCheck: { loading: true, error: false }
            };

        case SchedulerConstants.GET_SCHEDULER_EMPTY_CHECK_SUCCESS:
            return {
                ...state,
                emptyCheck: {
                    loading: false,
                    error: false,
                    ...action.payload
                }
            };

        case SchedulerConstants.GET_SCHEDULER_EMPTY_CHECK_FAILED:
            return {
                ...state,
                emptyCheck: { loading: false, error: true }
            };

        case SchedulerConstants.GET_SCHEDULER_REQUEST:
            return {
                ...state,
                data: { loading: true, error: false }
            };

        case SchedulerConstants.GET_SCHEDULER_SUCCESS:
            return {
                ...state,
                data: {
                    loading: false,
                    error: false,
                    ...action.payload
                }
            };

        case SchedulerConstants.GET_SCHEDULER_FAILED:
            return {
                ...state,
                data: { loading: false, error: true }
            };

        case SchedulerConstants.UPDATE_APPLIED_FILTERS:
            return {
                ...state,
                appliedFilters: { ...state.appliedFilters, ...action.payload }
            };

        default:
            return state;
    }
}